import { Link } from "react-router-dom";
import { useState } from "react"
import "./Gallery.css"

export default function Gallery() {
    const [totale, cambiaTotale] = useState(130);
    const [album, cambiaAlbum] = useState("cantieri");
    const [albumDisplay, setAlbumDisplay] = useState("Cantieri");
    const [foto, aggiornaFoto] = useState([
        {img : "https://infislab.it/foto/gallery/".concat(album,"1.jpg")},
        {img : "https://infislab.it/foto/gallery/".concat(album,"2.jpg")},
        {img : "https://infislab.it/foto/gallery/".concat(album,"3.jpg")},
        {img : "https://infislab.it/foto/gallery/".concat(album,"4.jpg")},
        {img : "https://infislab.it/foto/gallery/".concat(album,"5.jpg")},
        {img : "https://infislab.it/foto/gallery/".concat(album,"6.jpg")},
      ]);
    const [rimanenti, sottrai] = useState(124);
    const [icona1, setIcona1] = useState("home")
    const [icona2, setIcona2] = useState("construct-outline")
    const clickCategoria = (nuova, vecchia) => {
        cambiaAlbum(nuova);
        // swap active/not active
        document.getElementById(nuova).className = "scegli_album-active";
        document.getElementById(vecchia).className = "scegli_album";
        document.getElementById(nuova).name = "scegli_album-active";
        document.getElementById(vecchia).name = "scegli_album";
        // cambio foto
        aggiornaFoto([
            {img : "https://infislab.it/foto/gallery/".concat(nuova,"1.jpg")},
            {img : "https://infislab.it/foto/gallery/".concat(nuova,"2.jpg")},
            {img : "https://infislab.it/foto/gallery/".concat(nuova,"3.jpg")},
            {img : "https://infislab.it/foto/gallery/".concat(nuova,"4.jpg")},
            {img : "https://infislab.it/foto/gallery/".concat(nuova,"5.jpg")},
            {img : "https://infislab.it/foto/gallery/".concat(nuova,"6.jpg")},
          ])
        if(nuova == "cantieri") {
            cambiaTotale(130);
            sottrai(124)
            cambiaStep(12)
            setIcona1("home")
            setIcona2("construct-outline")
            setAlbumDisplay("Cantieri")
        }
        else if(nuova=="nostraLavorazione"){
            cambiaTotale(18);
            sottrai(12)
            cambiaStep(12)
            setIcona1("home-outline")
            setIcona2("construct")
            setAlbumDisplay("Nostra lavorazione")
        }
    }

    const [step, cambiaStep] = useState(12);
    const showMore = () => {
                if(rimanenti<24 && rimanenti>12) cambiaStep(rimanenti-12);
                if(rimanenti<12) sottrai(0);
                else sottrai(rimanenti-12)
                for (let i = foto.length+1; i <= foto.length+step; i++)
                    if(rimanenti>0) aggiornaFoto(arr => 
                        [...arr, { img: "https://infislab.it/foto/gallery/".concat(album+i,".jpg") }])
        }

    return (
        <section>
            <h1>Gallery » {albumDisplay} </h1>
            <br/>
            <div className="portaFoto">
                <div className="scegli_album-active" 
                id="cantieri" onClick={() => clickCategoria("cantieri", "nostraLavorazione")}>
                    <ion-icon id="icone_categoria" name={icona1}></ion-icon>
                    <p style={{textAlign:"center"}}>Cantieri </p>
                </div>
                <div className="scegli_album" 
                id="nostraLavorazione" onClick={() => clickCategoria("nostraLavorazione", "cantieri")}>
                    <ion-icon id="icone_categoria" name={icona2}></ion-icon>
                    <p style={{textAlign:"center"}}>Nostra lavorazione </p>
                </div>
            </div>
            <br/>
            <p className="help" style={{textAlign:"center"}}>
                ↑ Seleziona una delle due raccolte,
                poi clicca su una foto sottostante per passare alla slideshow.
            </p>
            <br/>
            <div className="portaFoto">
                {
                    foto.map((slide, index) => {
                        return(
                            <Link to={"/gallery/".concat(album,index+1)}>
                                <div>
                                    <img src={slide.img} 
                                    alt="" className="foto" loading="lazy"/>
                                </div>
                            </Link>
                        )
                    })
                }
            </div>
            <p className="button" onClick={() => showMore()} style={{zIndex:"100", cursor:"pointer"}}>
                <b>mostra altro (+{rimanenti}) </b>
            </p>
            <br/>
        </section>
    )
}